"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const SvgVideo360 = props => (0, jsx_runtime_1.jsx)("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36
}, props, {
  children: (0, jsx_runtime_1.jsxs)("g", Object.assign({
    "data-name": "Group 864"
  }, {
    children: [(0, jsx_runtime_1.jsx)("path", {
      fill: "none",
      d: "M0 0h36v36H0z"
    }, void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 777"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Rectangle",
        fill: "none",
        d: "M0-.001h36v36H0z"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsxs)("g", Object.assign({
      "data-name": "Group 857"
    }, {
      children: [(0, jsx_runtime_1.jsxs)("g", Object.assign({
        "data-name": "Group 857"
      }, {
        children: [(0, jsx_runtime_1.jsx)("g", Object.assign({
          "data-name": "Path 550"
        }, {
          children: (0, jsx_runtime_1.jsx)("path", {
            "data-name": "Path 554",
            d: "M10.083 10.738c0-1.365-.476-1.734-1.233-1.734s-1.236.412-1.236 1.5v.976H5.362v-.824c0-2.426 1.212-3.813 3.553-3.813s3.553 1.387 3.553 3.813v.39a2.953 2.953 0 01-1.669 3.121 3.1 3.1 0 011.669 3.186v1.192c0 2.426-1.214 3.812-3.553 3.812s-3.553-1.385-3.553-3.812v-1.26h2.252v1.41c0 1.083.477 1.495 1.236 1.495s1.233-.369 1.233-1.71v-1.195c0-1.407-.476-1.927-1.56-1.927h-.8v-2.172h.93c.886 0 1.431-.39 1.431-1.6z",
            fill: "#2d5dec"
          }, void 0)
        }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
          "data-name": "Path 551"
        }, {
          children: (0, jsx_runtime_1.jsx)("path", {
            "data-name": "Path 555",
            d: "M13.902 10.781c0-2.556 1.168-3.943 3.64-3.943 2.339 0 3.553 1.387 3.553 3.813v.39H18.84v-.542c0-1.084-.477-1.5-1.236-1.5-.843 0-1.32.412-1.32 1.864v2.774a2.27 2.27 0 012.215-1.342c1.754 0 2.643 1.233 2.643 3.466v2.773a3.623 3.623 0 01-7.237.359q-.009-.179 0-.359zm2.382 5.178v2.732c0 1.083.477 1.477 1.236 1.477s1.233-.39 1.233-1.477v-2.732c0-1.084-.477-1.495-1.233-1.495s-1.236.411-1.236 1.495z",
            fill: "#2d5dec"
          }, void 0)
        }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
          "data-name": "Path 552"
        }, {
          children: (0, jsx_runtime_1.jsx)("path", {
            "data-name": "Path 556",
            d: "M22.421 10.651a3.624 3.624 0 017.237-.414 3.223 3.223 0 010 .414v7.888a3.623 3.623 0 11-7.237.359q-.009-.179 0-.359zm2.385 8.038c0 1.083.476 1.495 1.233 1.495s1.236-.412 1.236-1.495v-8.191c0-1.084-.477-1.5-1.236-1.5s-1.233.412-1.233 1.5z",
            fill: "#2d5dec"
          }, void 0)
        }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
          "data-name": "Path 553"
        }, {
          children: (0, jsx_runtime_1.jsx)("path", {
            "data-name": "Path 557",
            d: "M32.783 6.838a2.146 2.146 0 11-2.146 2.146 2.138 2.138 0 012.127-2.144zm0 3.206a1.062 1.062 0 10-1.062-1.062 1.064 1.064 0 001.062 1.062z",
            fill: "#2d5dec"
          }, void 0)
        }), void 0)]
      }), void 0), (0, jsx_runtime_1.jsxs)("g", Object.assign({
        "data-name": "Group 858",
        fill: "#2d5dec"
      }, {
        children: [(0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 558",
          d: "M34.186 20.587a7.747 7.747 0 00-3.279-5.968v3.129a4.661 4.661 0 011.063 2.838c0 3.388-4.337 6.349-10.144 7.355v2.246c7.188-1.104 12.36-4.921 12.36-9.6z"
        }, void 0), (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 559",
          d: "M3.079 20.587A4.65 4.65 0 014.12 17.78v-3.146a7.735 7.735 0 00-3.256 5.95c0 5.2 6.374 9.343 14.817 9.874v-2.224c-6.996-.5-12.602-3.8-12.602-7.647z"
        }, void 0)]
      }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
        "data-name": "Group 859"
      }, {
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 560",
          d: "M19.19 29.415l-2.989 1.534-2.989 1.534.168-3.354.166-3.356 2.823 1.822z",
          fill: "#2d5dec"
        }, void 0)
      }), void 0)]
    }), void 0)]
  }), void 0)
}), void 0);

exports.default = SvgVideo360;